import { Layout } from 'antd';
import { IWrapperProps } from '../entities';

const BCFooter = (props: IWrapperProps) => <Layout.Footer {...props} />;

export default BCFooter;
